/* GEHNA: floating WhatsApp button + small "chat helper" popup (all pages).
   The popup shows ready-made questions; tapping one opens WhatsApp chat with that message already typed.
   On product pages the product name + link is added automatically.
   Edit NUMBER / BRAND / opening hours below. NUMBER = country code + number, digits only (91 = India). */
(function () {
  if (window.__gxWhatsapp) return;
  window.__gxWhatsapp = true;

  var NUMBER = '919700360179';
  var BRAND = 'GEHNA OFFICIAL';
  var OPEN_DAYS = [1, 2, 3, 4, 5, 6];   /* 0 = Sunday ... 6 = Saturday */
  var OPEN_FROM = 10;                    /* 10 AM (IST) */
  var OPEN_TO = 17;                      /* 5 PM (IST) */

  var CSS = ''
    + '.gx-wa{position:fixed;left:16px;bottom:16px;z-index:90;font-family:inherit}'
    + '.gx-wa__btn{display:flex;align-items:center;justify-content:center;width:56px;height:56px;padding:0;border:0;border-radius:50%;background:#25D366;color:#fff;box-shadow:0 6px 18px rgba(0,0,0,0.25);cursor:pointer;-webkit-tap-highlight-color:transparent}'
    + '.gx-wa__btn:hover{transform:scale(1.05)}'
    + '.gx-wa__tip{position:absolute;left:66px;bottom:8px;width:max-content;max-width:210px;padding:10px 14px;background:#fff;border-radius:12px;box-shadow:0 6px 18px rgba(0,0,0,0.18);font-size:13px;line-height:1.35;color:#241F1C}'
    + '.gx-wa__tip[hidden]{display:none}'
    + '.gx-wa__panel{position:absolute;left:0;bottom:70px;width:min(92vw,340px);overflow:hidden;background:#fff;border-radius:16px;box-shadow:0 12px 36px rgba(0,0,0,0.25);text-align:left}'
    + '.gx-wa__panel[hidden]{display:none}'
    + '.gx-wa__head{display:flex;align-items:center;gap:12px;padding:14px 16px;background:#075E54;color:#fff}'
    + '.gx-wa__avatar{flex:none;display:flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:50%;background:#25D366}'
    + '.gx-wa__name{margin:0;font-size:15px;font-weight:600;line-height:1.2}'
    + '.gx-wa__status{margin:2px 0 0;font-size:12px;opacity:0.85}'
    + '.gx-wa__close{margin-left:auto;padding:0;width:28px;height:28px;border:0;background:transparent;color:#fff;font-size:22px;line-height:1;cursor:pointer}'
    + '.gx-wa__body{padding:14px 14px 6px;background:#ECE5DD}'
    + '.gx-wa__bubble{display:inline-block;max-width:88%;margin:0 0 10px;padding:10px 12px;background:#fff;border-radius:0 12px 12px 12px;font-size:14px;line-height:1.4;color:#241F1C}'
    + '.gx-wa__reply{display:block;width:100%;margin:0 0 8px;padding:10px 12px;background:#fff;border:1px solid #25D366;border-radius:999px;font:inherit;font-size:13.5px;font-weight:600;text-align:left;color:#075E54;cursor:pointer}'
    + '.gx-wa__reply:hover{background:#E9F9EF}'
    + '.gx-wa__foot{padding:10px 14px 14px;background:#ECE5DD}'
    + '.gx-wa__go{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:12px;background:#25D366;border:0;border-radius:999px;color:#fff;font:inherit;font-size:14px;font-weight:600;cursor:pointer}'
    + '@media screen and (max-width:749px){.gx-wa{left:12px;bottom:12px}.gx-wa__btn{width:52px;height:52px}.gx-wa__panel{bottom:64px}}';

  var ICON = '<svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>';

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function isOpen() {
    var n = new Date(Date.now() + 330 * 60000);   /* India time */
    var h = n.getUTCHours();
    return OPEN_DAYS.indexOf(n.getUTCDay()) > -1 && h >= OPEN_FROM && h < OPEN_TO;
  }

  function pageInfo() {
    var url = location.href.split('#')[0];
    var onProduct = location.pathname.indexOf('/products/') > -1;
    var title = '';
    if (onProduct) {
      var h = document.querySelector('.product__title h1') || document.querySelector('h1.product__title') || document.querySelector('.product__title') || document.querySelector('h1');
      title = h ? h.textContent.replace(/\s+/g, ' ').trim() : String(document.title).split(' \u2013 ')[0].trim();
    }
    return { url: url, onProduct: onProduct, title: title };
  }

  function openChat(text) {
    window.open('https://wa.me/' + NUMBER + '?text=' + encodeURIComponent(text), '_blank', 'noopener');
  }

  var HI = 'Hi ' + BRAND + '! ';
  var REPLIES = [
    { onlyProduct: true, label: '\ud83d\udecd\ufe0f I have a question about this product', text: function (p) { return HI + 'I have a question about this product: ' + p.title + ' ' + p.url; } },
    { label: '\ud83d\udce6 Order status / tracking', text: function () { return HI + 'I would like to know the status / tracking of my order. Order number: '; } },
    { label: '\ud83d\ude9a Delivery & shipping', text: function () { return HI + 'I have a question about delivery and shipping. My pincode: '; } },
    { label: '\ud83d\udd01 Return / exchange', text: function () { return HI + 'I need help with a return / exchange. Order number: '; } },
    { label: '\ud83c\udf81 Offers & coupons', text: function () { return HI + 'I would like to know about current offers and coupon codes.'; } },
    { label: '\ud83d\udcac Something else', text: function (p) { return HI + 'I need some help. ' + (p.onProduct ? p.url : ''); } }
  ];

  function build() {
    if (document.querySelector('.gx-wa')) return;
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var root = el('div', 'gx-wa');

    var tip = el('div', 'gx-wa__tip', 'Need help? Chat with us on WhatsApp \ud83d\udc4b');
    tip.hidden = true;
    root.appendChild(tip);

    var panel = el('div', 'gx-wa__panel');
    panel.hidden = true;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Chat on WhatsApp');

    var head = el('div', 'gx-wa__head');
    var av = el('div', 'gx-wa__avatar');
    av.innerHTML = ICON.replace('width="30"', 'width="24"').replace('height="30"', 'height="24"');
    head.appendChild(av);
    var who = el('div');
    who.appendChild(el('p', 'gx-wa__name', BRAND));
    who.appendChild(el('p', 'gx-wa__status', isOpen() ? 'Online' : 'Mon-Sat, 10 AM - 5 PM'));
    head.appendChild(who);
    var x = el('button', 'gx-wa__close', '\u00d7');
    x.type = 'button';
    x.setAttribute('aria-label', 'Close');
    head.appendChild(x);
    panel.appendChild(head);

    var body = el('div', 'gx-wa__body');
    body.appendChild(el('div', 'gx-wa__bubble', 'Hello! \ud83d\udc4b Welcome to ' + BRAND + '. How can we help you today?'));
    if (!isOpen()) {
      body.appendChild(el('div', 'gx-wa__bubble', 'We are currently offline. Leave us a message and we will reply between Mon-Sat, 10 AM - 5 PM.'));
    }
    var info = pageInfo();
    REPLIES.forEach(function (r) {
      if (r.onlyProduct && !info.onProduct) return;
      var b = el('button', 'gx-wa__reply', r.label);
      b.type = 'button';
      b.addEventListener('click', function () { openChat(r.text(pageInfo())); });
      body.appendChild(b);
    });
    panel.appendChild(body);

    var foot = el('div', 'gx-wa__foot');
    var go = el('button', 'gx-wa__go');
    go.type = 'button';
    go.innerHTML = ICON.replace('width="30"', 'width="18"').replace('height="30"', 'height="18"') + '<span>Chat on WhatsApp</span>';
    go.addEventListener('click', function () { openChat(HI + 'I need some help.'); });
    foot.appendChild(go);
    panel.appendChild(foot);
    root.appendChild(panel);

    var btn = el('button', 'gx-wa__btn');
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Chat on WhatsApp');
    btn.innerHTML = ICON;
    root.appendChild(btn);

    function setOpen(o) {
      panel.hidden = !o;
      if (o) tip.hidden = true;
    }
    btn.addEventListener('click', function () { setOpen(panel.hidden); });
    x.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) setOpen(false); });

    document.body.appendChild(root);

    /* small "need help?" hint, once per visit */
    var seen = false;
    try { seen = sessionStorage.getItem('gx_wa_tip') === '1'; } catch (err) {}
    if (!seen) {
      setTimeout(function () {
        if (!panel.hidden) return;
        tip.hidden = false;
        try { sessionStorage.setItem('gx_wa_tip', '1'); } catch (err) {}
        setTimeout(function () { tip.hidden = true; }, 7000);
      }, 4000);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
